/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useMemo, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { debounce } from "../../../utils/common";
import { capitalizeFirstLetter } from "../../helpers/format";
import { useParams } from "react-router-dom";
import { Chip } from "@mui/material";

interface IAutocompleteMultiSelect {
  name: string;
  label: string;
  onSelect: (data: any[]) => void;
  selectedValues: any[] | undefined;
  func: (...args: any) => Promise<any>;
  touched?: boolean;
  error?: string;
  handleBlur?: (e: any) => void;
  dependentValue?: any;
  disabled?: boolean;
  disabledOnEdit?: boolean;
  isValueDependent?: string | boolean;
  helperText?: string;
}

const AutocompleteMultiSelect: FC<IAutocompleteMultiSelect> = ({
  onSelect,
  selectedValues,
  func,
  label,
  name,
  touched,
  error,
  handleBlur,
  dependentValue = false,
  disabled = false,
  disabledOnEdit = false,
  isValueDependent = false,
  helperText,
}) => {
  const params = useParams();

  const [first, updateFirst] = useState(false);

  useEffect(() => {
    if (dependentValue && first) {
      onSelect([]);
    } else {
      updateFirst(true);
    }
  }, [dependentValue]);
  const [options, setOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = async (text: string, dependValue: string) => {
    setInputValue(text);
    setLoading(true);
    let data;
    if (dependValue) {
      data = await func(text, dependValue);
    } else {
      if (!isValueDependent) data = await func(text);
    }
    // let data = await func(text);
    if (data) {
      setOptions(data);
    }
    setLoading(false);
  };

  const debounceHandleInputChange = useMemo(
    () => debounce(handleInputChange, 300),
    []
  );

  useEffect(() => {
    debounceHandleInputChange(inputValue, dependentValue);
  }, [debounceHandleInputChange, inputValue, dependentValue]);

  return (
    <>
      <Autocomplete
        disabled={disabled || ((params?.id && disabledOnEdit) as boolean)}
        value={selectedValues || []}
        onChange={(_, newValue) => {
          onSelect(newValue);
        }}
        onInputChange={(_, newInputValue) => {
          debounceHandleInputChange(newInputValue);
        }}
        loading={loading}
        options={options}
        onBlur={handleBlur}
        getOptionDisabled={(option) => {
          if (Array.isArray(selectedValues)) {
            return (
              selectedValues?.some(
                (value) =>
                  value?.id === option?.id &&
                  value?.regionId === option?.regionId
              ) || false
            );
          }
          return false;
        }}
        renderTags={(tagValue, getTagProps) => {
          return tagValue?.map((option, index) => (
            <Chip
              label={option?.label}
              {...getTagProps({ index })}
              disabled={option?.disable || false}
            />
          ));
        }}
        freeSolo
        limitTags={2}
        multiple
        renderInput={(params) => (
          <TextField
            {...params}
            error={(error && touched) as boolean}
            name={name}
            label={label}
            helperText={
              helperText ||
              (touched && error ? capitalizeFirstLetter(error) : "")
            }
          />
        )}
      />

      {touched && error && (
        <p className="text-red-600 text-sm mb-2">
          {capitalizeFirstLetter(error)}
        </p>
      )}
    </>
  );
};

export default AutocompleteMultiSelect;
